<template>
  <div class="mt-1 ml-2">
    <v-btn class="mb-4 mr-1" icon x-large color="primary" link @click="onClickBack">
      <v-icon>
        mdi-arrow-left
      </v-icon>
    </v-btn>
    <span class="display-1">
      {{ oferta.titulo }}
    </span>
    <div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span class="subtitle-1" v-on="on">{{ oferta.codigo }}</span>
        </template>
        <span>Código de referência</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    oferta: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onClickBack() {
      this.$router.push({
        name: 'main.ofertas',
      });
    },
  },
};
</script>
